import React from 'react'

const User = props => (
  <svg width={24} height={24} {...props}>
    <path
      d="M15.436 11.618A4.973 4.973 0 0017 8V6A5 5 0 107 6v2c0 1.428.606 2.707 1.565 3.618C4.738 13.021 2 16.686 2 21v1c0 .55.451 1 1 1h18c.55 0 1-.45 1-1v-1c0-4.314-2.736-7.979-6.564-9.382"
      fillRule="evenodd"
      fill={props.fill}
    />
  </svg>
)

export default User
